/* @flow */

import { useSelector, shallowEqual } from 'react-redux';

import { getWhatIsBraindateURL } from 'src/shared/app/base/selector/appEnvSelectors';

export default function useWhatIsBraindateURL(): string {
  return useSelector(getWhatIsBraindateURL, shallowEqual);
}
